interface DismissibleChipProps {
  label: string;
  onRemove: () => void;
}

const DismissibleChip = ({ label, onRemove }: DismissibleChipProps) => (
  <div className="inline-flex items-center gap-1.5 select-none whitespace-nowrap rounded-full bg-primary/10 border border-primary/20 py-1.5 px-3 font-sans text-xs font-semibold text-primary transition-all hover:bg-primary/15">
    <span className="truncate max-w-[150px]">{label}</span>
    <button
      onClick={onRemove}
      className="flex-shrink-0 flex items-center justify-center h-4 w-4 rounded-full text-primary/60 transition-all hover:bg-primary/20 hover:text-primary"
      type="button"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        className="w-3 h-3"
        strokeWidth="2.5"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>
  </div>
);

export default DismissibleChip;
